import React, { useState } from 'react';
import {
    Box,
    Button,
    Card,
    CardContent,
    TextField,
    Typography,
    CircularProgress
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../services/axiosInstance';
import nwLogo from '../assets/images/Infinium.png';
import splashImage from '../assets/images/infiniumsplash.png';

const ForgotPasswordPage = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        setSuccess('');
        setError('');
        try {
            await axiosInstance.post('/admin/request-password-reset', { email });
            setSuccess('If an account exists for this email, a reset link has been sent.');
        } catch (err) {
            setError('An error occurred. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box position="relative" height="100vh" overflow="hidden">
    {/* Logo */}
    <Box sx={{ position: 'absolute', top: 15, left: 15, zIndex: 10 }}>
        <a href="https://infinium.consulting/" target="_blank" rel="noopener noreferrer">
            <img
                src={nwLogo}
                alt="Infinium Logo"
                style={{ height: '60px', objectFit: 'contain' }}
            />
        </a>
    </Box>

    {/* Full Background Image */}
    <Box
        sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
        }}
    >
        <img
            src={splashImage}
            alt="splash"
            style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                display: 'block'
            }}
        />
    </Box>

    {/* Forgot Password Form - Upper Left */}
    <Box
        sx={{
            position: 'absolute',
            top: '15%',
            left: '8%',
            zIndex: 5,
        }}
    >
        <Card sx={{ p: 4, borderRadius: 4, boxShadow: 8, width: 380 }}>
            <CardContent>
                <Typography variant="h4" fontWeight="bold" gutterBottom>
                    Reset Password
                </Typography>
                <Typography color="text.secondary" variant="body2" gutterBottom>
                    Enter your email and we'll send a reset link
                </Typography>

                <form onSubmit={handleSubmit}>
                    <TextField
                        label="Email Address"
                        type="email"
                        fullWidth
                        margin="normal"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        fullWidth
                        sx={{ mt: 2 }}
                        disabled={loading}
                    >
                        {loading ? <CircularProgress size={24} color="inherit" /> : 'Send Reset Link'}
                    </Button>
                </form>

                {success && (
                    <Typography color="primary" variant="body2" mt={2}>
                        {success}
                    </Typography>
                )}
                {error && (
                    <Typography color="error" variant="body2" mt={2}>
                        {error}
                    </Typography>
                )}
                <Typography
                    variant="caption"
                    display="block"
                    mt={3}
                    textAlign="center"
                    sx={{ cursor: 'pointer' }}
                    onClick={() => navigate('/login')}
                >
                    Back to login
                </Typography>
            </CardContent>
        </Card>
    </Box>
</Box>
    );
};

export default ForgotPasswordPage;
